import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall } from "./axiosMethodCalls";
const user = getUser();
const token = getToken();

//GET
export const getCategory = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "categories/get",
            {
                requester: user,
                token: token,
                name: data.name,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// get subcategory
export const getSubcategory = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "categories/get_subcategories",
            {
                requester: user,
                token: token,
                category_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createCategory = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "categories/create",
            {
                requester: user,
                token: token,
                name: info.name,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateCategory = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "categories/update",
            {
                requester: user,
                token: token,
                product_ids: info.id,
                name: info.name,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "categories/delete",
            {
                requester: user,
                token: token,
                category_id: id,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};